import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProductoCementoDto, ProductoCementoUpsertDto } from '../models/producto-cemento.dto';
import { ServerListQuery, ServerPaginatedResponse } from '../models/server-list.model';

@Injectable()
export class ProductoCementoApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}cemento/admin-products/`;

  listProductos(query: ServerListQuery): Observable<ServerPaginatedResponse<ProductoCementoDto>> {
    const params = new HttpParams()
      .set('page', String(query.page))
      .set('page_size', String(query.pageSize))
      .set('search', query.search)
      .set('ordering', query.ordering);
    return this.http.get<ServerPaginatedResponse<ProductoCementoDto>>(this.baseUrl, { params });
  }

  createProducto(payload: ProductoCementoUpsertDto): Observable<void> {
    return this.http.post<unknown>(this.baseUrl, payload).pipe(map(() => undefined));
  }

  updateProducto(id: number, payload: ProductoCementoUpsertDto): Observable<void> {
    return this.http.put<unknown>(`${this.baseUrl}${id}/`, payload).pipe(map(() => undefined));
  }

  deleteProducto(id: number): Observable<void> {
    return this.http.delete<unknown>(`${this.baseUrl}${id}/`).pipe(map(() => undefined));
  }

  postExcelCargaMasiva(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('excel', file);
    return this.http
      .post<unknown>(`${this.baseUrl}cargar_excel/`, formData)
      .pipe(map(() => undefined));
  }
}
